import BpkIconAirport from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/airports';
import BusIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/bus';
import BpkIconSelfService from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/self-service';
import {
  BpkBox,
  BpkFlex,
  BpkSpacing,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import STYLES from './PickUpType.module.scss';

const PICKUP_TYPES = {
  TERMINAL_DESK: 'TERMINAL_DESK',
  SHUTTLE_BUS: 'SHUTTLE_BUS',
  MEET_AND_GREET: 'MEET_AND_GREET',
};

type TagProps = {
  text: string;
  icon?: React.ReactNode;
};

const Tag = ({ icon = undefined, text }: TagProps) => (
  <BpkBox
    marginTop={BpkSpacing.SM}
    marginBottom={BpkSpacing.SM}
    marginStart={BpkSpacing.None}
    marginEnd={BpkSpacing.SM}
  >
    <BpkVessel className={STYLES.Tag}>
      <BpkFlex
        align="center"
        paddingBlock={BpkSpacing.SM}
        paddingInline={BpkSpacing.MD}
      >
        {icon && (
          <BpkFlex as="span" paddingEnd={BpkSpacing.SM} data-testid="tag-icon">
            {icon}
          </BpkFlex>
        )}
        <BpkText textStyle={TEXT_STYLES.bodyDefault}>{text}</BpkText>
      </BpkFlex>
    </BpkVessel>
  </BpkBox>
);

type PickUpTypeProps = {
  pickupTypes?: Record<string, string>;
};

const getIcon = (type: string): React.ReactNode | undefined => {
  switch (type) {
    case PICKUP_TYPES.TERMINAL_DESK:
      return <BpkIconAirport />;
    case PICKUP_TYPES.MEET_AND_GREET:
      return <BpkIconSelfService />;
    case PICKUP_TYPES.SHUTTLE_BUS:
      return <BusIcon />;
    default:
      return undefined;
  }
};

const PickUpTypes = ({ pickupTypes = {} }: PickUpTypeProps) => {
  const hasPickupTypes = pickupTypes && Object.keys(pickupTypes).length > 0;
  return (
    <BpkBox
      display="flex"
      flexWrap="wrap"
      marginBottom={BpkSpacing.Base}
      minHeight={hasPickupTypes ? undefined : '2rem'}
      data-testid="pickup-types"
    >
      {Object.entries(pickupTypes).map(([typeKey, displayText]) => (
        <Tag key={typeKey} icon={getIcon(typeKey)} text={displayText} />
      ))}
    </BpkBox>
  );
};

export default PickUpTypes;
